"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleLineP = exports.Text = exports.P = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.rulesForTextProps = exports.fontSize = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var spacing_1 = require("./spacing");
var helpers_1 = require("../util/helpers");
var layout_1 = require("../util/layout");
var fontSize = function (size, base) {
    if (size === void 0) { size = 1; }
    if (base === void 0) { base = 1; }
    return "font-size: ".concat((0, helpers_1.rem)(size, base), ";");
};
exports.fontSize = fontSize;
var colorRule = function (color) {
    return color ? "color: ".concat(color, ";") : '';
};
var lineHeightRule = function (lineHeight) {
    return lineHeight ? "line-height: ".concat(lineHeight, "%;") : '';
};
var rulesForTextProps = function (_a) {
    var center = _a.center, color = _a.color, error = _a.error, lineHeight = _a.lineHeight, weight = _a.weight, size = _a.fontSize, _b = _a.ellipsis, ellipsis = _b === void 0 ? false : _b, theme = _a.theme;
    return "\n  margin: 0;\n  word-wrap: break-word;\n  ".concat(center ? 'text-align: center;' : '', "\n  ").concat(error ? colorRule(theme.colors.error) : '', "\n  ").concat(colorRule(color), "\n  ").concat(lineHeightRule(lineHeight), "\n  ").concat((0, helpers_1.passThroughRule)('font-weight', weight), "\n  ").concat(size ? (0, exports.fontSize)(size, theme.typography.baseSize) : '', ";\n\n  ").concat(ellipsis
        ? "\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
        : '', "\n");
};
exports.rulesForTextProps = rulesForTextProps;
var tagMap = {};
var nativeTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h5', 'p', 'span'];
var components = nativeTags.reduce(function (memo, tag) {
    if (memo === void 0) { memo = {}; }
    // @ts-ignore
    memo[tag] = react_1.default.forwardRef(function (props, ref) { return (react_1.default.createElement(spacing_1.SpacingContainer, __assign({ ref: ref }, props, { as: tag }))); });
    return memo;
}, tagMap);
exports.H1 = (0, styled_components_1.default)(components.h1)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n  ", "\n  font-weight: 300;\n  line-height: 1.25;\n\n  @media (max-width: ", "px) {\n    ", "\n  }\n\n  ", "\n"], ["\n  color: ", ";\n  ", "\n  ", "\n  font-weight: 300;\n  line-height: 1.25;\n\n  @media (max-width: ", "px) {\n    ", "\n  }\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
}, function (_a) {
    var theme = _a.theme;
    return (0, exports.fontSize)(3, theme.typography.baseSize);
}, function (_a) {
    var theme = _a.theme;
    return (0, helpers_1.passThroughRule)('font-family', theme.typography.h1);
}, (0, layout_1.breakPoint)('sm'), function (_a) {
    var theme = _a.theme;
    return (0, exports.fontSize)(2, theme.typography.baseSize);
}, exports.rulesForTextProps);
exports.H2 = (0, styled_components_1.default)(components.h2)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n  ", "\n  font-weight: 400;\n  line-height: 1.25;\n\n  @media (max-width: ", "px) {\n    ", "\n  }\n\n  ", "\n"], ["\n  color: ", ";\n  ", "\n  ", "\n  font-weight: 400;\n  line-height: 1.25;\n\n  @media (max-width: ", "px) {\n    ", "\n  }\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
}, function (_a) {
    var theme = _a.theme;
    return (0, exports.fontSize)(2, theme.typography.baseSize);
}, function (_a) {
    var theme = _a.theme;
    return (0, helpers_1.passThroughRule)('font-family', theme.typography.headingType);
}, (0, layout_1.breakPoint)('sm'), function (_a) {
    var theme = _a.theme;
    return (0, exports.fontSize)(1.625, theme.typography.baseSize);
}, exports.rulesForTextProps);
exports.H3 = (0, styled_components_1.default)(components.h3)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n  ", "\n  font-weight: 400;\n  line-height: 1.25;\n\n  @media (max-width: ", "px) {\n    ", "\n  }\n\n  ", "\n"], ["\n  color: ", ";\n  ", "\n  ", "\n  font-weight: 400;\n  line-height: 1.25;\n\n  @media (max-width: ", "px) {\n    ", "\n  }\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
}, function (_a) {
    var theme = _a.theme;
    return (0, exports.fontSize)(1.5, theme.typography.baseSize);
}, function (_a) {
    var theme = _a.theme;
    return (0, helpers_1.passThroughRule)('font-family', theme.typography.headingType);
}, (0, layout_1.breakPoint)('sm'), function (_a) {
    var theme = _a.theme;
    return (0, exports.fontSize)(1.375, theme.typography.baseSize);
}, exports.rulesForTextProps);
exports.H4 = (0, styled_components_1.default)(components.h4)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n  ", "\n  font-weight: 400;\n  line-height: 1.25;\n\n  @media (max-width: ", "px) {\n    ", "\n  }\n\n  ", "\n"], ["\n  color: ", ";\n  ", "\n  ", "\n  font-weight: 400;\n  line-height: 1.25;\n\n  @media (max-width: ", "px) {\n    ", "\n  }\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
}, function (_a) {
    var theme = _a.theme;
    return (0, exports.fontSize)(1.25, theme.typography.baseSize);
}, function (_a) {
    var theme = _a.theme;
    return (0, helpers_1.passThroughRule)('font-family', theme.typography.headingType);
}, (0, layout_1.breakPoint)('sm'), function (_a) {
    var theme = _a.theme;
    return (0, exports.fontSize)(1.125, theme.typography.baseSize);
}, exports.rulesForTextProps);
exports.H5 = (0, styled_components_1.default)(components.h5)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n  ", "\n  font-weight: 400;\n  letter-spacing: 1px;\n  line-height: 1.25;\n\n  ", "\n"], ["\n  color: ", ";\n  ", "\n  ", "\n  font-weight: 400;\n  letter-spacing: 1px;\n  line-height: 1.25;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
}, function (_a) {
    var theme = _a.theme;
    return (0, exports.fontSize)(0.75, theme.typography.baseSize);
}, function (_a) {
    var theme = _a.theme;
    return (0, helpers_1.passThroughRule)('font-family', theme.typography.headingType);
}, exports.rulesForTextProps);
exports.P = (0, styled_components_1.default)(components.p)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n  line-height: 1.5;\n\n  ", "\n"], ["\n  color: ", ";\n  ", "\n  line-height: 1.5;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
}, function (_a) {
    var theme = _a.theme;
    return (0, exports.fontSize)(1, theme.typography.baseSize);
}, exports.rulesForTextProps);
exports.Text = (0, styled_components_1.default)(components.span)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n  line-height: 1.5;\n\n  ", "\n"], ["\n  color: ", ";\n  ", "\n  line-height: 1.5;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
}, function (_a) {
    var theme = _a.theme;
    return (0, exports.fontSize)(1, theme.typography.baseSize);
}, exports.rulesForTextProps);
exports.SingleLineP = (0, styled_components_1.default)(components.p)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n  line-height: 1.25;\n\n  ", "\n"], ["\n  color: ", ";\n  ", "\n  line-height: 1.25;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
}, function (_a) {
    var theme = _a.theme;
    return (0, exports.fontSize)(1, theme.typography.baseSize);
}, exports.rulesForTextProps);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=typography.js.map